// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"51":"581d204a1b25f8445a87","948":"fdb81743e07931ef1303"}[chunkId] + ".css";
};